<template>
  <transition name="surprised">
    <div v-if="value" class="surprised">
      <div class="title">{{title}}</div>
      <div class="core">
        <img src="/static/images/1508/rotate.png" class="rotate"/>
        <img :src="iconUrl" class="awardsImg"/>
        <div class="awardsText">{{awardsText}}</div>
      </div>
      <img src="/static/images/1508/close.png" class="close" @click="close()"/>
      <div class="overlay"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "surprised",

  props: {
    value:{
      type: Boolean,
      default: function(){
        return false
      },
    },

    awardsText:{
      type: String,
      default: ''
    },

    iconUrl:{
      type: String,
      default: ''
    },

    title:{
      type: String,
      default: '领取成功'
    },
  },

  data(){
    return{
    }
  },

  methods:{
    close(){
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">

.surprised-enter,
.surprised-leave-to{
  opacity: 0
}

.surprised-leave-active,
.surprised-enter-active {
  //transition: opacity 0.5s;
  transition-duration: .5s;
}

.surprised{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12vh 0 0;
  box-sizing: border-box;

  .title{
    font-size: 5.4vh;
    font-family: FZZongYi-M05S;
    color: #FFFC39;
    font-weight: bold;
    line-height: 1;
  }

  @keyframes rotate{
    0%{
      transform: rotate(0deg);
    }

    100%{
      transform: rotate(360deg);
    }
  }

  .core{
    width: 47.9vh;
    height: 47.9vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .rotate{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      animation: rotate 3s linear infinite;
      z-index: -1;
    }

    .awardsImg{
      width: 27.1vh;
      height: 27.1vh;
    }

    .awardsText{
      position: absolute;
      bottom: 3.8vh;
      color: #FFFC39;
      font-size: 3.3vh;
      text-align: center;
    }
  }

  .close{
    width: 4.7vh;
    height: 4.7vh;
    margin-top: 10.6vh;
  }

  .overlay{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .7);
    transition-duration: 2300ms;
    opacity: 1;
    z-index: -2;
  }
}



</style>